"use client";
import { cn } from "../lib/utils.js";
import { jsx, jsxs } from "react/jsx-runtime";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
//#region src/components/tooltip.tsx
/** Wraps your app to provide global functionality to your tooltips. */
function TooltipProvider({ delayDuration = 0, ...props }) {
	return /* @__PURE__ */ jsx(TooltipPrimitive.Provider, {
		"data-slot": "tooltip-provider",
		delayDuration,
		...props
	});
}
/** The root component that controls the open state of the tooltip. It wraps the tooltip content and trigger. */
function Tooltip({ ...props }) {
	return /* @__PURE__ */ jsx(TooltipPrimitive.Root, {
		"data-slot": "tooltip",
		...props
	});
}
/** The button that toggles the tooltip. By default, the Tooltip.Content will position itself against the trigger. */
function TooltipTrigger({ ...props }) {
	return /* @__PURE__ */ jsx(TooltipPrimitive.Trigger, {
		"data-slot": "tooltip-trigger",
		...props
	});
}
/** The component that pops out when the tooltip is open. */
function TooltipContent({ className, sideOffset = 0, children, ...props }) {
	return /* @__PURE__ */ jsx(TooltipPrimitive.Portal, { children: /* @__PURE__ */ jsxs(TooltipPrimitive.Content, {
		"data-slot": "tooltip-content",
		sideOffset,
		className: cn("tw", "tw:bg-midnight tw:text-white", "tw:animate-in tw:fade-in-0 tw:zoom-in-95", "tw:data-[state=closed]:animate-out tw:data-[state=closed]:fade-out-0 tw:data-[state=closed]:zoom-out-95", "tw:data-[side=bottom]:slide-in-from-top-2 tw:data-[side=left]:slide-in-from-right-2 tw:data-[side=right]:slide-in-from-left-2 tw:data-[side=top]:slide-in-from-bottom-2", "tw:z-50 tw:w-fit tw:max-w-xs tw:origin-(--radix-tooltip-content-transform-origin)", "tw:rounded-md tw:new:rounded-xs tw:px-3 tw:py-1.5", "tw:text-xs", className),
		...props,
		children: [children, /* @__PURE__ */ jsx(TooltipPrimitive.Arrow, { className: cn("tw", "tw:bg-midnight tw:fill-midnight", "tw:z-50 tw:size-2.5 tw:translate-y-[calc(-50%_-_2px)]", "tw:rotate-45 tw:rounded-[2px] tw:new:rounded-[1px]") })]
	}) });
}
//#endregion
export { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger };

//# sourceMappingURL=tooltip.js.map